import React, { useEffect } from 'react';
import _ from 'lodash';
import { makeStyles } from '@material-ui/core/styles';
import { Grid, Hidden } from '@material-ui/core';

import { MainColumn, RightColumn } from 'layouts/RadioMain/container';

import LoginRoot from 'modules/login';
import Playbar from 'modules2/Playbar';

import container from './RadioPage.container';

const useStyles = makeStyles((theme) => ({
  mainAreaOffset: {
    display: 'flex',
    justifyContent: 'center',
    marginTop: 10,
    // marginBottom: 30,
    paddingBottom: 160,
    background: theme.palette.bodyColor,
    color: theme.palette.textColor,
    [theme.breakpoints.down('md')]: {
      marginTop: 10,
    },
    [theme.breakpoints.down('sm')]: {
      marginTop: 10,
    },
    [theme.breakpoints.down('xs')]: {
      marginTop: 10,
    },
  },
  mainColumn: {
    position: 'relative',
    maxWidth: '728px',
    width: '100%',
    marginLeft: 10,
    marginRight: 10,
    marginBottom: 70,
    [theme.breakpoints.down('md')]: {
      marginLeft: 0,
      marginRight: 0,
    },
  },
  rightColumn: {
    position: 'relative',
    width: '300px',
    marginLeft: '10px',
    marginRight: '10px',
  },
}));

const RadioPage = (props) => {
  const classes = useStyles();
  const {
    userState: { profile },
    radioState: { radios, fiveStar },
    playerRadioState: { stationid, player },
    userhistoryRadioState: { heartedStationIds, history },
    onFetchRadioListStart,
    onGetHeartsRadioStationStart,
    onFavouriteRadioStation,
    onDeleteFavoriteRadioStation,
    onToggleRadioPlayPause,
    onShowSnackbarNotification,
    onGetHistoryRadioStationStart,
    onSetRadioUrl,
    onAddPlayRadioStationStart,
    onRatingHandleStart,
    location,
  } = props;
  const radioList = {...history, ...radios};
  const randomNumber = Math.floor(Math.random() * 4);
  const isFiveStar = fiveStar.some((starStationId) => starStationId === stationid) ? 5 : randomNumber;

  useEffect(() => {
    onFetchRadioListStart();
  }, []);

  useEffect(() => {
    if (!_.isEmpty(profile.uid)) {
      onGetHeartsRadioStationStart();
      onGetHistoryRadioStationStart();
      onSetRadioUrl();
    }
  }, [profile]);

  return (
    <>
      <LoginRoot />
      <Grid container className={classes.mainAreaOffset}>
        <Grid item className={classes.mainColumn}>
          <MainColumn />
        </Grid>
        <Hidden mdDown>
          <Grid item className={classes.rightColumn}>
            <RightColumn />
          </Grid>
        </Hidden>
      </Grid>
      {stationid && (
        <Playbar
          location={location}
          stationid={stationid}
          isFiveStar={isFiveStar}
          playing={player.playing}
          station={radioList[stationid]}
          image={radioList[stationid].favicon}
          title={radioList[stationid].name}
          subtitle={radioList[stationid].tags}
          url={radioList[stationid].url_resolved}
          radio_id={radioList[stationid].stationuuid}
          country={radioList[stationid].country}
          state={radioList[stationid].state}
          radio={radioList[stationid]}
          togglePlaying={onToggleRadioPlayPause}
          heartedStationIds={heartedStationIds}
          onFavouriteRadioStation={onFavouriteRadioStation}
          onDeleteHeartRadioStation={onDeleteFavoriteRadioStation}
          onShowSnackbarNotification={onShowSnackbarNotification}
          onAddPlayRadioStationStart={onAddPlayRadioStationStart}
          onRatingHandleStart={onRatingHandleStart}
        />
      )}
    </>
  );
};

export default container(RadioPage);
